var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4998_188848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.332 12H10.6654C10.3117 12 9.9726 12.1405 9.72256 12.3905C9.47251 12.6406 9.33203 12.9797 9.33203 13.3333V26.6667C9.33203 27.0203 9.47251 27.3594 9.72256 27.6095C9.9726 27.8595 10.3117 28 10.6654 28H29.332C29.6857 28 30.0248 27.8595 30.2748 27.6095C30.5249 27.3594 30.6654 27.0203 30.6654 26.6667V13.3333C30.6654 12.9797 30.5249 12.6406 30.2748 12.3905C30.0248 12.1405 29.6857 12 29.332 12ZM28.3054 26.6667H11.772L16.4387 21.84L15.4787 20.9133L10.6654 25.8933V14.3467L18.952 22.5933C19.2018 22.8417 19.5398 22.9811 19.892 22.9811C20.2443 22.9811 20.5822 22.8417 20.832 22.5933L29.332 14.14V25.8067L24.4254 20.9L23.4854 21.84L28.3054 26.6667ZM11.5387 13.3333H28.252L19.892 21.6467L11.5387 13.3333Z",
    fill: "#2962FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4998_188848)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4986 27.1002L24.7486 25.3502C24.5536 25.1552 24.2436 25.1552 24.0486 25.3502C23.8536 25.5452 23.8536 25.8552 24.0486 26.0502L26.1436 28.1452C26.3386 28.3402 26.6536 28.3402 26.8486 28.1452L32.1486 22.8502C32.3436 22.6552 32.3436 22.3452 32.1486 22.1502C31.9536 21.9552 31.6436 21.9552 31.4486 22.1502L26.4986 27.1002Z",
    fill: "#008060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4998_188848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4998_188848"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteMessageIcon);
export default __webpack_public_path__ + "static/media/complete-message-icon.c76747e4b61084ff31dc3985cce705a8.svg";
export { ForwardRef as ReactComponent };